import { AxiosResponse } from "axios";
import axios from "../../../lib/axios";
import { API_ENDPOINTS } from "../../../constants/api_endpoints";
import { TResponse } from "../../../types/common";
import { IIntegration, IIntegrationConnectUrl, IIntegrationHubData, IXeroStatus, IXeroAuthUrl, IXeroSyncResult, IQBStatus, IQBAuthUrl, IQBSyncResult, IGCalStatus, IGCalAuthUrl } from "../../../types/api/integrations";

// ─── Legacy callbacks ──────────────────────────────────────────────────────────

export async function listIntegrations(): Promise<AxiosResponse<TResponse<IIntegration[]>>> {
  return axios.get<TResponse<IIntegration[]>>(API_ENDPOINTS.INTEGRATION_LIST);
}

export async function getIntegrationConnectUrl(
  provider: string
): Promise<AxiosResponse<TResponse<IIntegrationConnectUrl>>> {
  return axios.get<TResponse<IIntegrationConnectUrl>>(
    API_ENDPOINTS.INTEGRATION_CONNECT_URL(provider)
  );
}

export async function disconnectIntegration(
  id: number
): Promise<AxiosResponse<TResponse<null>>> {
  return axios.delete<TResponse<null>>(API_ENDPOINTS.INTEGRATION_DISCONNECT(id));
}

// ─── Hub callbacks ─────────────────────────────────────────────────────────────

export async function listHubIntegrations(): Promise<AxiosResponse<TResponse<IIntegrationHubData>>> {
  return axios.get<TResponse<IIntegrationHubData>>("/integrations/hub");
}

export async function connectHubIntegration(
  slug: string,
  body: { api_key?: string; config?: Record<string, any> }
): Promise<AxiosResponse<TResponse<{ slug: string; status: string }>>> {
  return axios.post(`/integrations/hub/${slug}/connect`, body);
}

export async function testHubIntegration(
  slug: string
): Promise<AxiosResponse<TResponse<{ ok: boolean; message: string }>>> {
  return axios.post(`/integrations/hub/${slug}/test`);
}

export async function disconnectHubIntegration(
  slug: string
): Promise<AxiosResponse<TResponse<null>>> {
  return axios.delete(`/integrations/hub/${slug}`);
}

// ─── Xero callbacks ────────────────────────────────────────────────────────────

export async function getXeroStatus(): Promise<AxiosResponse<TResponse<IXeroStatus>>> {
  return axios.get<TResponse<IXeroStatus>>("/integrations/xero/status");
}

export async function getXeroAuthUrl(): Promise<AxiosResponse<TResponse<IXeroAuthUrl>>> {
  return axios.get<TResponse<IXeroAuthUrl>>("/integrations/xero/auth-url");
}

export async function disconnectXero(): Promise<AxiosResponse<TResponse<null>>> {
  return axios.post<TResponse<null>>("/integrations/xero/disconnect");
}

export async function syncInvoiceToXero(
  invoiceId: number
): Promise<AxiosResponse<TResponse<IXeroSyncResult>>> {
  return axios.post<TResponse<IXeroSyncResult>>(`/integrations/xero/sync-invoice/${invoiceId}`);
}

export async function syncClientToXero(
  clientId: number
): Promise<AxiosResponse<TResponse<IXeroSyncResult>>> {
  return axios.post<TResponse<IXeroSyncResult>>(`/integrations/xero/sync-client/${clientId}`);
}

// ─── QuickBooks callbacks ──────────────────────────────────────────────────────

export async function getQBStatus(): Promise<AxiosResponse<TResponse<IQBStatus>>> {
  return axios.get<TResponse<IQBStatus>>("/integrations/quickbooks/status");
}

export async function getQBAuthUrl(): Promise<AxiosResponse<TResponse<IQBAuthUrl>>> {
  return axios.get<TResponse<IQBAuthUrl>>("/integrations/quickbooks/auth-url");
}

export async function disconnectQB(): Promise<AxiosResponse<TResponse<null>>> {
  return axios.post<TResponse<null>>("/integrations/quickbooks/disconnect");
}

export async function syncInvoiceToQB(
  invoiceId: number
): Promise<AxiosResponse<TResponse<IQBSyncResult>>> {
  return axios.post<TResponse<IQBSyncResult>>(`/integrations/quickbooks/sync-invoice/${invoiceId}`);
}

export async function syncClientToQB(
  clientId: number
): Promise<AxiosResponse<TResponse<IQBSyncResult>>> {
  return axios.post<TResponse<IQBSyncResult>>(`/integrations/quickbooks/sync-client/${clientId}`);
}

// ─── Google Calendar callbacks ─────────────────────────────────────────────────

export async function getGCalStatus(): Promise<AxiosResponse<TResponse<IGCalStatus>>> {
  return axios.get<TResponse<IGCalStatus>>("/integrations/google-calendar/status");
}

export async function getGCalAuthUrl(): Promise<AxiosResponse<TResponse<IGCalAuthUrl>>> {
  return axios.get<TResponse<IGCalAuthUrl>>("/integrations/google-calendar/auth-url");
}

export async function disconnectGCal(): Promise<AxiosResponse<TResponse<null>>> {
  return axios.post<TResponse<null>>("/integrations/google-calendar/disconnect");
}
